import styled from 'styled-components';

export const StyledTitle = styled.h1`
  font-weight: 600;
  font-size: 26px;
  line-height: 130%;
  letter-spacing: 0.01em;
  color: var(--color-link);
`;
